import * as React from 'react';
import { Link } from 'react-router-dom'
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import ReactPaginate from 'react-paginate';
import {
    fetchPublicaciones,
    fetchVariaciones,
    fetchMarcas,
    fetchCategorias,
    editPublicacion,
    fetchPublicacionesEncabezado,
    resetMarcaYCategoria,
    resetPublicaciones,
    updateListPublicacionesEstado,
    setFiltroPublicacion
} from '../../../actions/publicacionesActions';
import { limpiarFiltros } from '../../../actions/generalActios';
import { fetchSellersFilter } from '../../../actions/sellersActions';
import { fetchTiposPublicacionAdm } from '../../../actions/tiposPublicacionActions';
import {
    postAprobarPublicacionApi,
    updatePublicacionApi,
    postDesaprobarPublicacionApi
} from '../../../api/axios';
import PublicacionListItem from './PublicacionListItem';
import PublicacionesFilter from './PublicacionesFilter';
import BigSpinner from "../../General/BigSpinner";
import BtnToggleFilter from "../../General/Filter/BtnToggleFilter";
import { toast } from 'react-toastify';
import { filtroMedioMes } from '../../../utilities/fechasFiltro';
import { getEstadoPublicacionFromId } from '../../../helper/publicacionHelper';
import { setFiltroOrdenes } from '../../../actions/ordenesActions';
import { withNavigation } from '../../General/withNavigation';

// Wrapper para usar hooks en class component
function ListPublicacionesWrapper(props) {
    const navigate = useNavigate();
    return <ListPublicaciones {...props} navigate={navigate} />;
}

const fechaFiltro = filtroMedioMes();

class ListPublicaciones extends React.Component {
    constructor(props) {
        super(props);
        const storedPage = parseInt(localStorage.getItem("pagina"), 10);
        const initialPage = storedPage && storedPage > 0 ? storedPage : 1;
        this.state = {
            currentPage: initialPage,
            onFilter: true,
            listaTipoPublicacionCargada: false,
            idPublicacionEstado: 0,
            idPublicacionEstadoAnterior: 0,
            estado: ""
        }
    }

    componentDidMount() {
        const { location, publicaciones } = this.props;

        if (location?.state?.shouldFetch) {
            this.busquedaPublicaciones();
            this.props.navigate(location.pathname, { replace: true, state: {} });
            return;
        }

        if (location?.state?.onSubmitSuccess) {
            this.busquedaPublicaciones();
            this.props.navigate(location.pathname, { replace: true, state: {} });
            return;
        }

        if (publicaciones?.length > 0) {
            return;
        }

        localStorage.setItem("snerL", -1);

        if (this.props.userType.isCategory || this.props.isAdminMod) {
            this.props.fetchSellersFilter(null);
        }

        this.busquedaPublicaciones();
        this.props.editPublicacion({});
        const pag = localStorage.getItem("pagina");
        this.setState({ currentPage: pag != null ? pag : 1 });
        this.props.fetchVariaciones();
        this.cargarTipoPublicacionLista();
        this.props.fetchCategorias();
        this.props.fetchMarcas();
    }


    cargarTipoPublicacionLista = () => {
        let listaTipoPublicacion = { params: { "CantidadPagina": 100 } };
        if (!this.state.listaTipoPublicacionCargada) {
            if (this.props.userType.isCategory || this.props.userType.isAdminMod) {
                this.props.fetchTiposPublicacionAdm(listaTipoPublicacion);
            } else {
                this.props.fetchTiposPublicacionAdm(this.props.idSeller);
            }
        }
        this.setState({ listaTipoPublicacionCargada: true });
    }

    busquedaPublicaciones = () => {
        let filtroPublicacion = this.props.filtroPublicacion;

        if (filtroPublicacion.fechaPubHasta === undefined) {
            filtroPublicacion.fechaPubHasta = fechaFiltro.hasta;
        }

        if (filtroPublicacion.fechaPubDesde === undefined) {
            filtroPublicacion.fechaPubDesde = fechaFiltro.desde;
        }

        this.props.fetchPublicacionesEncabezado({
            idSeller: (this.props.userType.isCategory || this.props.userType.isAdminMod) ? this.props.filtroPublicacion.idSeller : this.props.idSeller,
            categoria: filtroPublicacion.categoria,
            marca: filtroPublicacion.marca,
            estado: filtroPublicacion.estado,
            skuSeller: filtroPublicacion.skuSeller,
            skuMarket: filtroPublicacion.skuMarket,
            fechaPubDesde: filtroPublicacion.fechaPubDesde,
            fechaPubHasta: filtroPublicacion.fechaPubHasta,
            idTipoPubli: filtroPublicacion.idTipoPubli,
            sinStock: filtroPublicacion.sinStock,
            pagina: localStorage.getItem("pagina"),
            entidadOrdenamiento: "idPublicacion",
            idPublicacion: isNaN(filtroPublicacion.idPublicacion) ? null : filtroPublicacion.idPublicacion,
        });
    }

    onPublicacion = (idSellerBusca, idPublicacion, idSellerPublicacion, tieneRebate) => {

        localStorage.setItem("pId", idPublicacion);

        let pathReturn = `/Publicaciones`
        this.props.navigate(`/Publicaciones/Editar/${idSellerBusca}/${idPublicacion}`, {
            state: {
                pathReturn: pathReturn,
                idSellerPub: idSellerPublicacion,
                tieneRebate: tieneRebate
            }
        });
    }

    onOrdenes = (event, skuMarket) => {
        event.stopPropagation();
        this.props.setFiltroOrdenes({ skuMarket: skuMarket, fechaDesde: "2023-10-01", desdePublicacion: true });

        let pathReturn = `/Publicaciones`
        this.props.navigate(`/Ordenes/Publicacion`, {
            state: {
                pathReturn: pathReturn
            }
        });
    }


    setInitialPage = () => {
        this.setState({ currentPage: 1 });
    }

    aprobarPublicacion = (idPublicacion) => {

        const req = postAprobarPublicacionApi({ idPublicacion: idPublicacion });

        req.then(res => {
            toast.success("Publicación aprobada");
            this.props.updateListPublicacionesEstado(idPublicacion, 1);
            //this.busquedaPublicaciones();
        }).catch(err => {
            (err.response.data.errores)
                ? err.response.data.errores.forEach(error => toast.error(error))
                : toast.error("No pudo aprobarse");
        });
    }

    getHandleEstado = (idPublicacion) => {
        this.setState({ idPublicacionEstado: idPublicacion });
    }

    handlePageChange = (options) => {
        const selectedPage = options.selected + 1;
        localStorage.setItem("pagina", selectedPage);

        if (this.props.publicaciones && this.props.publicaciones.length > 0) {
            localStorage.setItem("snerL", this.props.publicaciones[0].idPublicacion);
        }

        this.setState({ currentPage: selectedPage }, () => {
            this.busquedaPublicaciones(selectedPage);
        });
    }


    handleEstado = (event, args) => {
        const { idPublicacionEstado } = this.state;
        const argsEstado = getEstadoPublicacionFromId(args.estado);
        event.stopPropagation();
        this.setState({ idPublicacionEstadoAnterior: this.state.idPublicacionEstado });
        switch (argsEstado) {
            case "activo":
                const reqDesaprobar = postDesaprobarPublicacionApi({ IdPublicacion: this.state.idPublicacionEstado });
                reqDesaprobar.then(res => {
                    toast.success("Publicación desaprobada");

                    //El método desaprobar cambia de estado 1(activo) a estado 4(en revisión)
                    this.props.updateListPublicacionesEstado(idPublicacionEstado, 4)
                }).catch(err => {
                    (err.response.data.errores)
                        ? err.response.data.errores.forEach(error => toast.error(error))
                        : toast.error("No pudo desaprobarse");
                });
                break;
            case "pausado":
                this.aprobarPublicacion(this.state.idPublicacionEstado);
                //this.props.updateListPublicacionesEstado(idPublicacionEstado, 1)
                break;
            case "pendiente_activacion":
                this.aprobarPublicacion(this.state.idPublicacionEstado);
                //this.props.updateListPublicacionesEstado(idPublicacionEstado, 1)
                break;
            case "en_revision":
                this.aprobarPublicacion(this.state.idPublicacionEstado);
                //this.props.updateListPublicacionesEstado(idPublicacionEstado, 1)
                break;
            default: break;
        }
    }

    setStatePublicacion = (idPublicacion, estado) => {

        if (idPublicacion == this.state.idPublicacionEstadoAnterior) return;

        const req = updatePublicacionApi({ idPublicacion: idPublicacion, estado: estado });

        req.then(res => {
            toast.success("Se modificó el estado correctamente");
            this.busquedaPublicaciones();
        }).catch(err => {
            (err.response.data.errores)
                ? err.response.data.errores.forEach(error => toast.error(error))
                : toast.error("No pudo modificarse");
        });
    }

    filtrarPublicaciones = (filtros) => {
        this.props.setFiltroPublicacion(filtros);
        this.setState({ currentPage: 1 }, () => {
            this.busquedaPublicaciones();
        });
    };


    render() {

        const { onFilter } = this.state;
        const { userType, publicaciones, loadingPublicaciones, cantidadTotal, cantidades, idSeller } = this.props;
        return (
            <div>
                <div className="row page-titles">

                    <div className="col-md-3 align-self-center">
                        <h3 className="text-themecolor color-rojo-megatone">Publicaciones</h3>
                    </div>

                    <div className="col-md-7 align-self-center">
                        <div className="col-12 col-md-auto list-group list-group-horizontal-md">
                            {[
                                { label: "Cantidad Total", color: "primary", value: cantidadTotal ?? 0 },
                                { label: "En revisión", color: "secondary", value: cantidades?.enRevision ?? 0 },
                                { label: "Activos", color: "success", value: cantidades?.activos ?? 0 },
                                { label: "Con stock no publicados", color: "dark", value: cantidades?.conStockNoPublicados ?? 0 }
                            ].map((item, i) =>
                                <div className="list-group-item d-flex flex-column justify-content-between align-items-center" key={i}>
                                    <span className="d-block">{item.label}</span>
                                    <div className="d-inline-flex">
                                        <span className={`badge rounded-pill text-bg-${item.color}`} style={{ fontSize: "0.93em" }}>
                                            {item.value}
                                        </span>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>

                    <div className="col-12 col-md-2 button-group align-self-center text-center mt-2">
                        <BtnToggleFilter show={onFilter} handleShow={() => this.setState({ onFilter: !onFilter })} />
                        {!userType.isCategory && !userType.isAdminMod &&
                            <Link to={`/Publicaciones/Nueva/${idSeller}`}>

                                <button type="button" className="btn btn-sm background-rojo-megatone">
                                    <i className="fa fa-plus-circle mx-1" /> Crear Publicación
                                </button>
                            </Link>
                        }
                    </div>

                </div>

                <div hidden={!onFilter}>
                    <PublicacionesFilter
                        setInitialPage={this.setInitialPage}
                        allowSearchBySeller={userType.isCategory || userType.isAdminMod}
                        filtro={this.props.emptyFiltro.publicaciones === false ? this.props.filtroPublicacion : ""}
                        requestParaExportar={this.filtrarPublicaciones}
                        shouldFetchOnClear={true}
                    />
                </div>

                {loadingPublicaciones ? <BigSpinner /> :
                    <div>
                        {publicaciones?.length && publicaciones?.length > 0 ?
                            publicaciones.map((publicacion, i) => {
                                return (
                                    <a
                                        key={i}
                                        onMouseEnter={() => this.getHandleEstado(publicacion.idPublicacion)}
                                        onClick={() => {
                                            this.onPublicacion(
                                                idSeller,
                                                publicacion.idPublicacion,
                                                publicacion.idSeller,
                                                publicacion.tieneRebate
                                            )
                                        }}
                                    >
                                        <PublicacionListItem
                                            titulo={publicacion.titulo}
                                            skuSeller={publicacion.skuSeller}
                                            skuMarket={publicacion.skuMarket}
                                            categoria={publicacion.categoria}
                                            precioLista={publicacion.precioLista}
                                            precioPromocional={publicacion.precioPromocional}
                                            estado={publicacion.estado}
                                            img={publicacion.imagen.urlImagen}
                                            idPublicacion={publicacion.idPublicacion}
                                            marca={publicacion.marca}
                                            tipoEntrega={publicacion.tipoEntrega}
                                            fechaPublicacion={publicacion.fechaPublicacion}
                                            envioGratis={publicacion.envioGratis}
                                            handleEstado={this.handleEstado}
                                            descripcionSeller={publicacion.descripcionSeller}
                                            tipoPublicacion={publicacion.tipoPublicacion}
                                            stock={publicacion.stock}
                                            isAdminOrCategory={userType.isCategory || userType.isAdminMod}
                                            productoExceptuado={publicacion.exceptuado}
                                            onOrdenes={this.onOrdenes}
                                            descripcionUmbralStock={publicacion.descripcionUmbralStock}
                                        />
                                    </a>
                                )
                            })
                            :
                            <h5 className="d-flex justify-content-center my-4">NO SE ENCONTRARON RESULTADOS</h5>
                        }
                    </div>
                }

                <div className="d-flex justify-content-center">
                    <ReactPaginate
                        previousLabel={"Anterior"}
                        nextLabel={"Siguiente"}
                        breakLabel={"..."}
                        breakClassName={"break-me"}
                        pageCount={Math.ceil((this.props.cantidadTotal || 0) / 10)}
                        marginPagesDisplayed={5}
                        pageRangeDisplayed={10}
                        onPageChange={this.handlePageChange}
                        containerClassName={"pagination"}
                        subContainerClassName={"pages pagination"}
                        activeClassName={"active"}
                        forcePage={this.state.currentPage - 1}
                    />
                </div>
            </div>
        );
    }
}


const mapStateToProps = state => ({
    userType: state.general.userType,
    idSeller: state.general.idSeller,
    publicaciones: state.publicaciones.publicaciones.elementos,
    loadingPublicaciones: state.publicaciones.loadingPublicaciones,
    cantidadTotal: state.publicaciones.publicaciones.cantidadTotal,
    cantidades: state.publicaciones.publicaciones.cantidades,
    filtroPublicacion: state.publicaciones.filtroPublicaciones,
    emptyFiltro: state.general.limpiar
});

export default withNavigation(connect(mapStateToProps, {
    fetchPublicaciones,
    fetchCategorias,
    fetchVariaciones,
    fetchMarcas,
    fetchSellersFilter,
    editPublicacion,
    limpiarFiltros,
    fetchTiposPublicacionAdm,
    setFiltroOrdenes,
    fetchPublicacionesEncabezado,
    resetMarcaYCategoria,
    resetPublicaciones,
    updateListPublicacionesEstado,
    setFiltroPublicacion
})(ListPublicacionesWrapper));